<template>
  <div class="country-container pc">
    <div
      class="banner"
      :style="{ backgroundImage: `url(https://jkqj-assets-beijing.oss-cn-beijing.aliyuncs.com/global/covers/${data?.attributes?.country.data.attributes.shortCode!}.jpg)`}"
    >
      <div class="banner__mask"></div>
      <div class="banner__inner">
        <div class="left">
          <div class="title">
            <a-image
              class="flag"
              :src="`https://jkqj-assets-beijing.oss-cn-beijing.aliyuncs.com/global/flags_square/${data?.attributes?.country.data.attributes.shortCode}.png`"
              width="32"
              height="32"
              fit="cover"
              :preview="false"
            />
            <h1>
              {{
                locale === 'zh-CN'
                  ? data?.attributes?.country.data.attributes.cnName
                  : data?.attributes?.country.data.attributes.enName
              }}
            </h1>
          </div>
          <div class="desc">{{ $t('子站描述') }}</div>
          <ul class="ability-list">
            <template v-for="ability in Home.abilityList" :key="ability.name">
              <li class="ability-item">
                <nuxt-link :to="ability.path">
                  {{ $t(ability.name) }}
                </nuxt-link>
              </li>
            </template>
          </ul>
          <div class="btn-leads">
            <a-button
              class="free-charge"
              type="primary"
              @click="useLeadsInfo('免费领取用工指南', 'getFreeEmploymentGuide')"
              >{{ $t('免费领取用工指南') }}</a-button
            >
            <a-button class="get-expert-consultation" @click="getExpertAdvice">{{ $t('获取专家咨询') }}</a-button>
          </div>
        </div>
        <div class="right" v-if="relatedArticles?.length">
          <div class="national-dynamics">
            <nuxt-link class="right-nav" to="/info/news">
              {{ $t('国家动态') }}
              <icon-right class="icon" :strokeWidth="4" />
            </nuxt-link>
            <div class="list">
              <div
                class="dynamic-item"
                :class="{ active: index === articleIndex }"
                v-for="(article, index) in relatedArticles?.slice(0, 5)"
                :key="article.id"
              >
                <nuxt-link
                  class="dynamic"
                  :to="`/info/${article.attributes.category.data.attributes.name}/${article.id}`"
                >
                  <span class="marking">{{ index + 1 }}</span>
                  <span class="title-text">{{ article.attributes.title }}</span>
                </nuxt-link>
                <div class="date">{{ useDateFormat(new Date(article.attributes.updatedAt), 'MM/DD').value }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="tool">
      <div class="title">{{ $t('雇佣工具') }}</div>
      <div class="tool-list">
        <nuxt-link :to="tool.path" class="tool-item" v-for="tool in transToolsList" :key="tool.title">
          <a-image :src="tool.iconUrl" width="42" height="42px" :preview="false"/>
          <div class="content">
            <div class="name">
              {{ $t(tool.title) }}
              <icon-right class="icon" :strokeWidth="6" />
            </div>
            <div class="desc">{{ $t(tool.desc) }}</div>
          </div>
        </nuxt-link>
      </div>
    </div>
    <div class="guide">
      <div class="title">{{ $t('雇佣指南') }}</div>
      <div class="content">
        <div class="left">
          <div class="tabs">
            <div
              class="tab"
              :class="{ active: tabIndex === index }"
              v-for="(tab, index) in tabList"
              :key="tab.name"
              @click="handlerClickCatalogue(index)"
            >
              {{ $t(tab.title) }}
            </div>
          </div>
          <div class="article-content markdown-content" v-html="currentContent"></div>
          <a-button class="free-charge" type="primary" @click="useLeadsInfo('免费领取用工指南', 'contactUs')">{{
            $t('免费领取用工指南')
          }}</a-button>
          <div class="divider-wrapper">
            <a-divider class="divider" orientation="center">{{ $t('继续查看当地雇佣信息') }}</a-divider>
          </div>
          <div class="tabs center">
            <div
              class="tab"
              :class="{ active: tabIndex === index }"
              v-for="(tab, index) in tabList"
              :key="tab.name"
              @click="handlerClickCatalogue(index)"
            >
              {{ $t(tab.title) }}
            </div>
          </div>
        </div>
        <div class="right">
          <Leads
            :target-country="data?.attributes.country.data.attributes.cnName || ''"
            :entry="`${data?.attributes.country.data.attributes.cnName}-国家子站` || ''"
          />
          <div class="other-country">
            <div class="nav">
              <div class="title">{{ $t('其他国家雇佣指南') }}</div>
              <nuxt-link to="/resource/global" class="more">
                {{ $t('更多') }}
                <icon-right class="icon" :strokeWidth="4" :size="12" />
              </nuxt-link>
            </div>
            <div class="list" v-if="countryResult">
              <nuxt-link
                :to="`/resource/global/${moreItem.attributes.country.data.attributes.name}`"
                class="more-item"
                :style="{
                  backgroundImage: `url(https://jkqj-assets-beijing.oss-cn-beijing.aliyuncs.com/global/covers/${moreItem.attributes.country.data.attributes.shortCode}.jpg)`,
                }"
                v-for="moreItem in countryResult"
                :key="moreItem.id"
              >
                <div class="mask">{{ locale === 'zh-CN' ? moreItem.attributes.country.data.attributes.cnName : moreItem.attributes.country.data.attributes.enName }}</div>
              </nuxt-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="country-container mobile">
    <div
      class="banner"
      :style="{ backgroundImage: `url(https://jkqj-assets-beijing.oss-cn-beijing.aliyuncs.com/global/covers/${data?.attributes?.country.data.attributes.shortCode!}.jpg)`}"
    >
      <div class="banner__mask"></div>
      <div class="banner__inner">
        <div class="nav">
          <div class="title">
            <a-image
              class="flag"
              :src="`https://jkqj-assets-beijing.oss-cn-beijing.aliyuncs.com/global/flags_square/${data?.attributes?.country.data.attributes.shortCode}.png`"
              width="32"
              height="32"
              fit="cover"
              :preview="false"
            />
            <h1>{{ data?.attributes?.country.data.attributes.cnName }}</h1>
          </div>
          <div class="btn-leads">
            <a-button class="get-expert-consultation" @click="getExpertAdvice">获取专家咨询</a-button>
            <a-button
              class="free-charge"
              type="primary"
              @click="useLeadsInfo('免费领取用工指南', 'getFreeEmploymentGuide')"
              >免费领取用工指南</a-button
            >
          </div>
        </div>
        <div class="desc">
          DG.hire是全球领先的人力资源与薪酬管理平台。核心服务包括海外名义雇主、海外灵活用工、海外薪酬服务、全球招聘、用工合规咨询等。截至目前，我们的服务能力覆盖150+国家、120+货币、50+财税法专家支持。帮助近千家中国企业完成海外人力布局！
        </div>
        <ul class="ability-list">
          <template v-for="ability in Home.abilityList" :key="ability.name">
            <li class="ability-item">
              <nuxt-link :to="ability.path">
                {{ ability.name }}
              </nuxt-link>
            </li>
          </template>
        </ul>
      </div>
    </div>
    <div class="tool">
      <div class="title">雇佣工具</div>
      <div class="tool-list">
        <nuxt-link :to="tool.path" class="tool-item" v-for="tool in transToolsList" :key="tool.title">
          <a-image :src="tool.iconUrl" width="24" height="24" />
          <div class="name">{{ tool.title }}</div>
        </nuxt-link>
      </div>
    </div>
    <div class="guide">
      <div class="title">雇佣指南</div>
      <a-tabs class="tabs" @change="handleTabsChange">
        <a-tab-pane v-for="(tab, index) in tabList" :key="index" :title="tab.title" />
      </a-tabs>
      <div class="article-content markdown-content" v-html="currentContent"></div>
      <a-button class="free-charge" type="primary" @click="useLeadsInfo('免费领取用工指南', 'contactUs')"
        >免费领取用工指南</a-button
      >
    </div>
    <div v-if="relatedArticles?.length" class="national-dynamics">
      <div class="inner-dynamics">
        <nuxt-link to="/info/news" class="right-nav">
          国家动态
          <icon-right class="icon" :strokeWidth="4" />
        </nuxt-link>
        <div class="list">
          <div
            class="dynamic-item"
            :class="{ active: index === articleIndex }"
            v-for="(article, index) in relatedArticles?.slice(0, 5)"
            :key="article.id"
          >
            <nuxt-link class="dynamic" :to="`/info/${article.attributes.category.data.attributes.name}/${article.id}`">
              <span class="marking">{{ index + 1 }}</span>
              <span class="title-text">{{ article.attributes.title }}</span>
            </nuxt-link>
            <div class="date">{{ useDateFormat(new Date(article.attributes.updatedAt), 'MM/DD').value }}</div>
          </div>
        </div>
      </div>
    </div>
    <Leads
      class="leads"
      :target-country="data?.attributes.country.data.attributes.cnName || ''"
      :entry="`${data?.attributes.country.data.attributes.cnName}-国家子站` || ''"
    />
    <div class="other-country">
      <div class="nav">
        <div class="title">其他国家雇佣指南</div>
        <nuxt-link to="/resource/global" class="more">
          更多
          <icon-right class="icon" :strokeWidth="4" :size="12" />
        </nuxt-link>
      </div>
      <div class="list" v-if="countryResult">
        <nuxt-link
          :to="`/resource/global/${moreItem.attributes.country.data.attributes.name}`"
          class="more-item"
          :style="{
            backgroundImage: `url(https://jkqj-assets-beijing.oss-cn-beijing.aliyuncs.com/global/covers/${moreItem.attributes.country.data.attributes.shortCode}.jpg)`,
          }"
          v-for="moreItem in countryResult"
          :key="moreItem.id"
        >
          <div class="mask">{{ moreItem.attributes.country.data.attributes.cnName }}雇佣指南</div>
        </nuxt-link>
      </div>
    </div>
    <a-modal modalClass="get-expert-advice-modal" v-model:visible="modalVisible" :footer="false">
      <div class="title">获取专家咨询</div>
      <a-image src="https://jkqj-assets-beijing.oss-cn-beijing.aliyuncs.com/dghire/qrcode.jpg" />
      <div class="close-icon">
        <IconCloseCircle class="icon" :strokeWidth="2" @click="modalVisible = false" />
      </div>
    </a-modal>
  </div>
</template>

<script lang="ts" setup>
import { IDetail, IEntity, IList } from '@/@types/cms';
import type { IArea, IArticle, IGlobalRecruitment } from '@/@types/entities';
import { IconRight } from '@arco-design/web-vue/es/icon';
import { useDateFormat } from '@vueuse/core';
import { countryList as payInOneCountryList, deelCountryList, salaryToolCountryList } from '@/common/global';
import { salaryToolJobList } from '~~/common/global';
import useLeadsInfo from '@/composables/use-leads-info';
import { marked } from 'marked';
import Home from '@/assets/contents/home.json';
import { useI18n } from 'vue-i18n';

const { locale } = useI18n();
const employmentGuide = ['国家概况', '工资和税收', '休假政策', '法定休假', '入职', '解雇', '合同'];
const routes = [{ text: '资源中心' }, { text: '全球雇佣指南', path: '/resource/global' }, { text: '详情' }];
const countryList = ref<any[]>([]);
const articleIndex = ref(0);
const tabIndex = ref(0);

const result = await useAsyncData(async () => {
  const { data } = await useFetch<IList<IGlobalRecruitment>>(`/api/global/list`);
  const list = data.value?.data.map(item => ({
    ...item,
    url: `/resource/global/${item.attributes.country.data.attributes.name}`,
  }));
  const areaList = list?.reduce((res, item) => {
    const itemArea = item.attributes.area.data;
    if (res.findIndex(area => area.id === itemArea.id) < 0) {
      res.push(itemArea);
    }
    return res;
  }, [] as IEntity<IArea>[]);
  return {
    list,
    areaList,
  };
});

countryList.value = (result.data.value as any).list?.slice(0, 3);

const { countryName } = useRoute().params;
const { data } = await useAsyncData(async () => {
  const { data } = await useFetch<IDetail<IGlobalRecruitment>>(
    `/api/global/detail?countryName=${encodeURIComponent(countryName as string)}`
  );
  return data.value?.data;
});

// 请求国家推荐列表
const { data: countryResult } = await useAsyncData(async () => {
  const result = await useFetch<IEntity<IGlobalRecruitment>[]>(
    `/api/global/recommend-by-page?id=${data.value?.id || ''}`
  );
  return result.data.value;
});

if (!data.value?.id) {
  useLeadsInfo('下载更多国家资讯', 'freeDownload');
}

const { data: relatedArticles } = await useAsyncData(async () => {
  const { data: res } = await useFetch<IList<IArticle>>(
    `/api/article/list-by-country/?id=${data.value?.attributes?.country.data.id}`
  );
  return res.value?.data!;
});

if (relatedArticles.value?.length && relatedArticles.value?.length > 1) {
  const len = relatedArticles.value?.length;
  setInterval(() => {
    articleIndex.value++;
    if (articleIndex.value >= (len >= 5 ? 5 : len)) {
      articleIndex.value = 0;
    }
  }, 2000);
}

const {
  country: {
    data: { attributes: country },
  },
  tools,
} = data.value?.attributes as IGlobalRecruitment;

useSeoHead({
  title: country.cnName,
});

function handlerClickCatalogue(index: number) {
  tabIndex.value = index;
  document.querySelector('.tool')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
}

const transToolsList = computed(() => {
  if (!data.value?.attributes.country.data.attributes) {
    return [];
  }
  const { shortCode, name } = data.value.attributes.country.data.attributes;
  const list = [
    {
      title: '全球雇佣指南',
      desc: '查看150+国家雇佣资料',
      iconUrl: 'https://video.reta-inc.com/image/default/2FC68006C25046239EB3A11F1CB178C0-6-2.png',
      path: '/resource/global',
    },
  ];
  if (payInOneCountryList.concat(deelCountryList).find(c => c.code === shortCode)) {
    list.push({
      title: '雇佣成本计算器',
      desc: '估算企业用工总成本',
      iconUrl: 'https://video.reta-inc.com/image/default/FD889D56696242A4A0FE65997FA68404-6-2.png',
      path: `/resource/cost-calculator?amount=50000&countryCode=${shortCode}`,
    });
  }
  if (tools?.find(t => t.attributes.name === 'labor_employment_regulations')) {
    list.push({
      title: '全球劳动法',
      desc: '查看各国劳动法政策',
      iconUrl: 'https://video.reta-inc.com/image/default/68F2C54D61984A3D8DC97B6995106C4D-6-2.png',
      path: `/resource/global/${name}/labor-employment-regulations`,
    });
  }
  if (tools?.find(t => t.attributes.name === 'corporate_tax')) {
    list.push({
      title: '全球税收政策',
      desc: '查看各国用工税收政策',
      iconUrl: 'https://video.reta-inc.com/image/default/415911DBF3F14A90976B387FCA311264-6-2.png',
      path: `/resource/global/${name}/corporate-tax`,
    });
  }
  if (tools?.find(t => t.attributes.name === 'government_departments_relevant_institutions')) {
    list.push({
      title: '全球政府机构',
      desc: '了解150+国家政府机构信息',
      iconUrl: 'https://video.reta-inc.com/image/default/F4EAA87E64B34934BA33A1ACA9342760-6-2.png',
      path: `/resource/global/${name}/government-departments-relevant-institutions`,
    });
  }
  if (tools?.find(t => t.attributes.name === 'banks_insurance_companies')) {
    list.push({
      title: '全球银行保险机构',
      desc: '了解150+国家银保机构信息',
      iconUrl: 'https://video.reta-inc.com/image/default/EBAD19A3A5914FF1A030B98AA272C1C3-6-2.png',
      path: `/resource/global/${name}/banks-insurance-companies`,
    });
  }
  if (salaryToolCountryList?.find(s => s.value === shortCode)) {
    list.push({
      title: '全球薪酬洞察',
      desc: '了解全球市场员工薪酬信息',
      iconUrl: 'https://video.reta-inc.com/image/default/F07A75EC8B844A97A8B57C4D692AE827-6-2.png',
      path: `/resource/compensation-insight-tool-detail?countryCode=${shortCode}&jobTitle=${salaryToolJobList[0].value}`,
    });
  }
  if (payInOneCountryList.find(c => c.code === shortCode)) {
    list.push({
      title: '员工工资计算器',
      desc: '估算员工税后实得工资',
      iconUrl: 'https://video.reta-inc.com/image/default/6919A716887448C7ACFBED8B0489AA73-6-2.png',
      path: `/resource/wage-calculator?countryCode=${shortCode}&amount=50000`,
    });
  }
  return list;
});

const tabList = computed(() => {
  return (data.value?.attributes.additional || [])
    .map(attr => ({
      name: attr.attributes.category.data.attributes.name,
      title: attr.attributes.category.data.attributes.title,
      content: attr.attributes.content,
    }))
    .filter(el => employmentGuide.includes(el.title));
});

const currentContent = computed(() => {
  if (!tabList.value[tabIndex.value].content) {
    return '';
  }
  return marked.parse(tabList.value[tabIndex.value].content);
});

const handleTabsChange = (index: any) => {
  tabIndex.value = index;
};

const modalVisible = ref(false);
function getExpertAdvice() {
  modalVisible.value = true;
}
</script>
<style lang="less" scoped>
.country-container {
  padding-bottom: 60px;
  .banner {
    background-repeat: no-repeat;
    background-size: cover;
    position: relative;
    background-position: top center;
    &__mask {
      position: absolute;
      width: 100%;
      height: 100%;
      background: #052367;
      opacity: 0.6;
    }
  }
}

@media screen and (min-width: 800px) {
  .mobile {
    display: none;
  }
  .pc {
    display: block;
    background-color: #eff3fb;
    .banner {
      padding-bottom: 16px;
      min-height: 320px;
      &__inner {
        position: relative;
        max-width: 1280px;
        height: 100%;
        margin: 0 auto;
        box-sizing: border-box;
        overflow: hidden;
        display: flex;
        justify-content: space-between;
        .left {
          width: 680px;
          .title {
            margin-top: 40px;
            display: flex;
            align-items: center;
            .flag {
              border: 1px solid #ffffff;
              border-radius: 4px;
              margin-right: 16px;
            }

            .download {
              display: none !important;
            }

            & > h1 {
              font-weight: 600;
              font-size: 32px;
              line-height: 45px;
              color: #ffffff;
              margin: 0;
            }

            & > .arco-btn {
              margin-left: auto;
              display: flex;
              gap: 6px;
              padding: 0 24px;
              height: 48px;
            }
          }
          .desc {
            font-weight: 400;
            font-size: 14px;
            line-height: 20px;
            color: #ffffff;
            margin-top: 18px;
          }
          .ability-list {
            margin: 16px 0 0;
            display: flex;
            align-items: center;
            list-style: none;
            padding: 0;
            gap: 16px;

            .ability-item {
              padding: 5px 19px 5px 40px;
              border-radius: 16px;
              background: rgba(255, 255, 255, 0.24) url('@/assets/icons/country-substation-select.svg') no-repeat 13px
                center/18px 19px;
              a {
                font-weight: 400;
                font-size: 16px;
                line-height: 22px;
                color: #ffffff;
                text-decoration: none;
              }
            }
          }
          .btn-leads {
            margin-top: 24px;
            .free-charge,
            .get-expert-consultation {
              border-radius: 4px;
              height: 40px;
              font-size: 16px;
              font-weight: 500;
            }
            .free-charge {
              background: #165dff;
              &:hover {
                background: #4080ff;
              }
            }
            .get-expert-consultation {
              background: rgba(255, 255, 255, 0.7);
              color: #165dff;
              margin-left: 20px;
              &:hover {
                background: #ffffff;
              }
            }
          }
        }
        .right {
          width: 320px;
          height: 276px;
          background: rgba(15, 15, 15, 0.3);
          border-radius: 8px;
          margin-top: 22px;
          .national-dynamics {
            .right-nav {
              margin-top: 22px;
              padding: 0 20px;
              font-weight: 500;
              font-size: 20px;
              line-height: 26px;
              color: #ffffff;
              display: flex;
              align-items: center;
              text-decoration: none;
              .icon {
                font-size: 16px;
                margin-left: 4px;
              }
            }
            .list {
              padding: 0 12px;
              margin-top: 16px;
              display: flex;
              flex-direction: column;
              gap: 8px;
              .dynamic-item {
                line-height: 32px;
                padding: 4px 8px;
                display: flex;
                align-items: center;
                justify-content: space-between;
                .dynamic {
                  display: flex;
                  align-items: center;
                  width: 240px;
                  flex-shrink: 0;
                  color: #ffffff;
                  font-weight: 400;
                  font-size: 16px;
                  line-height: 24px;
                  color: #e5e7eb;
                  text-decoration: none;
                  .marking {
                    display: block;
                    background: #ff7d3c;
                    border-radius: 2px;
                    margin-right: 8px;
                    width: 18px;
                    line-height: 18px;
                    flex-shrink: 0;
                    text-align: center;
                    font-size: 14px;
                  }
                  .title-text {
                    flex: 1;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                  }
                }
                .date {
                  font-weight: 400;
                  font-size: 12px;
                  line-height: 24px;
                  color: #c9cdd4;
                }
                &.active {
                  background: rgba(255, 255, 255, 0.2);
                  border-radius: 4px;
                }
              }
            }
          }
        }
      }
    }

    .tool {
      width: 1280px;
      margin: 0 auto;
      margin-top: 32px;
      .title {
        font-weight: 500;
        font-size: 20px;
        line-height: 26px;
        color: #1d2129;
      }
      .tool-list {
        width: 100%;
        margin-top: 16px;
        padding: 24px 40px;
        background: linear-gradient(180deg, rgba(182, 251, 255, 0.2) 0%, rgba(188, 210, 255, 0) 22.46%), #ffffff;
        border: 1px solid #e8f0ff;
        border-radius: 8px;
        box-sizing: border-box;
        display: grid;
        grid-template-columns: 1fr 1fr 1fr 1fr;
        gap: 25px;
        .tool-item {
          display: flex;
          gap: 12px;
          align-items: center;
          text-decoration: none;
          .content {
            .name {
              font-weight: 500;
              font-size: 16px;
              line-height: 22px;
              color: #1d2129;
              display: flex;
              align-items: center;
              .icon {
                display: none;
                color: #165dff;
                margin-left: 6px;
              }
              &:hover {
                color: #165dff;
                .icon {
                  display: block;
                }
              }
            }
            .desc {
              font-weight: 400;
              font-size: 12px;
              line-height: 17px;
              color: #4e5969;
              margin-top: 3px;
            }
          }
        }
      }
    }

    .guide {
      width: 1280px;
      margin: 0 auto;
      margin-top: 32px;
      .title {
        font-weight: 500;
        font-size: 20px;
        line-height: 26px;
        color: #1d2129;
      }
      .content {
        display: flex;
        gap: 24px;
        margin-top: 16px;
        .left {
          width: 936px;
          flex-shrink: 0;
          background: linear-gradient(179.89deg, rgba(222, 255, 229, 0.2) 0.1%, rgba(188, 210, 255, 0) 6.08%), #ffffff;
          border: 1px solid #e8f0ff;
          border-radius: 8px;
          .tabs {
            padding: 20px 40px;
            border-bottom: 1px solid rgba(239, 243, 251, 0.5);
            display: flex;
            gap: 12px;
            flex-wrap: wrap;
            &.center {
              justify-content: center;
              padding-bottom: 40px;
              border: 0;
            }
            .tab {
              padding: 8px 20px;
              border: 1px solid #c9cdd4;
              border-radius: 8px;
              white-space: nowrap;
              font-size: 16px;
              line-height: 28px;
              color: #4e5969;
              cursor: pointer;
              &.active {
                background: rgba(22, 93, 255, 0.1);
                border-radius: 8px;
                padding: 9px 21px;
                border: 0;
                color: #386aff;
              }
            }
          }
          .article-content {
            padding: 0 40px;
            box-sizing: border-box;
          }
          .free-charge {
            height: 48px;
            font-weight: 500;
            font-size: 16px;
            padding: 0 36px;
            margin: 32px auto 0;
            display: block;
            border-radius: 4px;
          }
          .divider-wrapper {
            padding: 0 60px;
            margin-top: 54px;
            .divider {
              &:deep(.arco-divider-text) {
                font-weight: 400;
                font-size: 16px;
                line-height: 28px;
                color: #4e5969;
              }
            }
          }
        }
        .right {
          flex: 1;
          display: flex;
          flex-direction: column;
          gap: 32px;
          .other-country {
            display: flex;
            flex-direction: column;
            gap: 16px;
            .nav {
              display: flex;
              justify-content: space-between;
              align-items: center;
              .title {
                font-weight: 500;
                font-size: 20px;
                line-height: 28px;
                color: #1d2129;
              }
              .more {
                font-weight: 400;
                font-size: 16px;
                line-height: 22px;
                color: #86909c;
                text-decoration: none;
                display: flex;
                align-items: center;
              }
            }
            .list {
              display: flex;
              flex-direction: column;
              gap: 16px;
              .more-item {
                width: 100%;
                height: 140px;
                border-radius: 8px;
                background: no-repeat center center/cover;
                color: #ffffff;
                position: relative;
                overflow: hidden;
                cursor: pointer;
                .mask {
                  position: absolute;
                  background-color: rgba(5, 35, 103, 0.4);
                  width: 100%;
                  height: 100%;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  font-weight: 500;
                  font-size: 20px;
                  line-height: 28px;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
<style lang="less" scoped>
@media screen and (max-width: 800px) {
  .pc {
    display: none;
  }

  .mobile {
    padding-bottom: 32px;
    display: block;
    background-color: #fff;
    .banner {
      height: 322px;
      &__inner {
        position: relative;
        padding: 0 12px;
        overflow: hidden;
        .nav {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-top: 24px;
          padding-bottom: 16px;
          border-bottom: 1px solid rgba(239, 243, 251, 0.5);
          .title {
            display: flex;
            align-items: center;
            .flag {
              border: 1px solid #ffffff;
              border-radius: 4px;
            }
            h1 {
              font-weight: 600;
              font-size: 18px;
              line-height: 25px;
              color: #ffffff;
              margin: 0;
              margin-left: 8px;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
              max-width: 110px;
            }
          }
          .btn-leads {
            display: flex;
            gap: 8px;
            .free-charge,
            .get-expert-consultation {
              font-weight: 500;
              font-size: 12px;
              padding: 8px;
            }
            .free-charge {
              background: #165dff;
              border-radius: 4px;
            }
            .get-expert-consultation {
              background: rgba(255, 255, 255, 0.7);
              border-radius: 4px;
              color: #165dff;
            }
          }
        }
        .desc {
          font-weight: 400;
          font-size: 14px;
          line-height: 20px;
          color: #ffffff;
          margin-top: 16px;
        }
        .ability-list {
          margin: 16px 0 0;
          display: flex;
          align-items: center;
          list-style: none;
          padding: 0;
          gap: 12px;
          flex-wrap: wrap;

          .ability-item {
            padding: 5px 12px 5px 33px;
            border-radius: 16px;
            background: rgba(255, 255, 255, 0.24) url('@/assets/icons/country-substation-select.svg') no-repeat 12px
              center/16px 17px;
            a {
              font-weight: 400;
              font-size: 14px;
              line-height: 20px;
              color: #ffffff;
              text-decoration: none;
            }
          }
        }
      }
    }
    .tool {
      padding: 0 16px;
      .title {
        font-weight: 500;
        font-size: 18px;
        line-height: 26px;
        color: #1d2129;
        margin-top: 16px;
      }
      .tool-list {
        margin-top: 12px;
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 12px;
        .tool-item {
          display: flex;
          align-items: center;
          padding: 12px;
          gap: 8px;
          background: #ffffff;
          box-shadow: 0px 2px 16px rgba(135, 172, 255, 0.2);
          border-radius: 4px;
          text-decoration: none;
          .name {
            font-weight: 500;
            font-size: 14px;
            line-height: 20px;
            color: #1d2129;
          }
        }
      }
    }
    .guide {
      .title {
        font-weight: 500;
        font-size: 18px;
        line-height: 26px;
        color: #1d2129;
        margin-top: 32px;
        padding: 0 16px;
      }
      .tabs {
        position: sticky;
        top: 108px;
        margin-top: 12px;
        background-color: #fff;
        z-index: 9;
        ::-webkit-scrollbar {
          display: none;
        }
        :deep(.arco-tabs-nav-tab) {
          overflow: scroll;
        }
        :deep(.arco-tabs-nav-button) {
          display: none;
        }
        :deep(.arco-tabs-nav-tab-list) {
          padding-right: 32px;
          .arco-tabs-tab {
            margin: 0 0 0 16px;
          }
        }
      }
      .article-content {
        padding: 0 16px;
        box-sizing: border-box;
        margin-top: 0;
      }
      .free-charge {
        display: block;
        margin: 24px auto 0;
        border-radius: 4px;
        font-weight: 500;
        font-size: 14px;
        padding: 8px 20px;
        line-height: 20px;
        height: auto;
      }
    }
    .national-dynamics {
      padding: 0 16px;
      margin-top: 32px;
      .inner-dynamics {
        background: linear-gradient(180deg, rgba(255, 195, 162, 0.2) 0%, rgba(255, 255, 255, 0.2) 22.46%), #ffffff;
        border: 1px solid #f2f3f5;
        border-radius: 8px;
        padding: 20px 16px;
        .right-nav {
          display: flex;
          align-items: center;
          font-weight: 500;
          font-size: 18px;
          line-height: 26px;
          color: #1d2129;
          text-decoration: none;
          .icon {
            margin-left: 6px;
          }
        }
        .list {
          margin-top: 16px;
          display: flex;
          flex-direction: column;
          gap: 12px;
          .dynamic-item {
            height: 24px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            .dynamic {
              display: flex;
              text-decoration: none;
              font-weight: 400;
              font-size: 14px;
              line-height: 24px;
              color: #4e5969;
              align-items: center;
              .marking {
                flex-shrink: 0;
                text-align: center;
                background: #ff7d3c;
                border-radius: 2px;
                font-weight: 500;
                font-size: 14px;
                width: 18px;
                line-height: 18px;
                color: #ffffff;
                margin-right: 8px;
              }
              .title-text {
                max-width: 240px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
            }
          }
        }
      }
    }
    .leads {
      margin-top: 32px;
    }
    .other-country {
      margin-top: 32px;
      padding: 0 16px;
      .nav {
        display: flex;
        align-items: center;
        justify-content: space-between;
        .title {
          font-weight: 500;
          font-size: 18px;
          line-height: 26px;
          color: #1d2129;
        }
        .more {
          font-weight: 400;
          font-size: 16px;
          line-height: 22px;
          color: #86909c;
          text-decoration: none;
          display: flex;
          align-items: center;
        }
      }
      .list {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 12px;
        margin-top: 12px;
        .more-item {
          height: 100px;
          background: no-repeat center center/cover;
          border-radius: 8px;
          overflow: hidden;
          text-decoration: none;
          .mask {
            width: 100%;
            height: 100%;
            background-color: rgba(5, 35, 103, 0.4);
            display: flex;
            align-items: center;
            justify-content: center;
            font-weight: 500;
            font-size: 16px;
            line-height: 22px;
            color: #ffffff;
          }
        }
      }
    }
  }
}
</style>
<style lang="less">
.get-expert-advice-modal {
  background: linear-gradient(180deg, #ffffff 0%, #e6edff 100%);
  border: 1px solid #d8e4ff;
  box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.08);
  backdrop-filter: blur(2px);
  border-radius: 12px;
  .arco-modal-header {
    display: none;
  }
  .arco-modal-body {
    padding: 40px 70px 60px;
    position: relative;
    overflow: unset;
    .title {
      font-weight: 500;
      font-size: 24px;
      line-height: 34px;
      text-align: center;
      color: #1d2129;
      margin-bottom: 20px;
    }
    .close-icon {
      color: #ffffff;
      position: absolute;
      bottom: -60px;
      left: 0;
      right: 0;
      display: flex;
      justify-content: center;

      .icon {
        width: 42px;
        height: 42px;
      }
    }
  }
}
@media screen and (min-width: 800px) {
  .get-expert-advice-modal {
    width: 400px;
    .arco-image-img {
      width: 260px;
      height: 260px;
    }
  }
}
@media screen and (max-width: 800px) {
  .get-expert-advice-modal {
    width: calc(100% - 72px);
    .arco-modal-body {
      padding: 40px;
      display: flex;
      flex-direction: column;
      align-items: center;
      .arco-image-img {
        width: 220px;
        height: 220px;
      }
    }
  }
}
</style>
